<!-- eslint-disable vue/html-indent -->
<!-- eslint-disable vue/max-attributes-per-line -->
<template>
  <!-- 泵房管理 -->
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="12">
          <a-col :md="6" :sm="12">
            <a-form-item label="泵房名称">
              <a-input v-model="query.pumpName" placeholder="请输入泵房名称" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="泵房编号">
              <a-input v-model="query.pumpNo" placeholder="请输入泵房编号" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="建造年代">
              <a-date-picker format="YYYY-MM-DD" valueFormat="YYYY-MM-DD " v-model="query.buildingTime" />
            </a-form-item>

          </a-col>
          <a-col :md="6" :sm="12" style="display: flex">
            <a-form-item>
              <a-button type="primary" @click="queryList">查询</a-button>
            </a-form-item>
            <a-form-item style="margin-left: 12px">
              <a-button @click="resetList">重置</a-button>
            </a-form-item>
            <a-button type="primary" style="margin-left: 12px" @click="visiblenew">新增</a-button>
            <a-button type="danger" style="margin-left: 12px" @click="deleteSelectRow()">删除</a-button>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <a-table ref="table" rowKey="id" size="middle" bordered :columns="columns" :loading="dataListLoading"
      :dataSource="list" :pagination="pagination"
      :rowSelection="{ selectedRowKeys: this.selectedRows, onChange: onSelectChange }"
      :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)" @change="pageChange">
      <span slot="action" slot-scope="text, record">
        <a @click="addOrUHandle(record.id)">
          <!-- <a-icon type="edit" /> -->
          编辑
        </a>
      </span>
      <span slot="pumpUrl" slot-scope="text, record">
        <img v-if="record.pumpUrl !== ''" :src="record.pumpUrl" @click="pumpurlimg(record, 1)"
          style="width: 50px; height: 50px" />
      </span>
      <span slot="flowUrl" slot-scope="text, record">
        <img v-if="record.flowUrl !== ''" :src="record.flowUrl" alt="" @click="pumpurlimg(record, 2)"
          style="width: 50px; height: 50px" />
      </span>
    </a-table>
    <!-- 图片展示 -->
    <a-modal :title="titi" style="top: 20px" :width="800" :footer="null" :visible="visibles"
      :confirm-loading="confirmLoading" @cancel="handleCancelh">
      <img :src="this.pumpUrlg" :alt="this.pumpUrlg" style="width: 100%; height: 100%" />
    </a-modal>
    <!-- 添加位置 -->
    <a-modal title="地图" style="top: 20px" :width="800" v-model="mapVisible" @ok="mapVisible = false"
      @cancel="mapVisible = false">
      <LonlatMap ref="lonlatMaps" @handleMapOk="handleMapOk"></LonlatMap>
    </a-modal>
    <!-- 新增弹框 -->
    <a-modal :title="this.title" style="top: 20px" :width="800" :visible="visible" :confirm-loading="confirmLoading"
      :destroyOnClose="true" okText="确定" @ok="handleOk" @cancel="handleCancel">
      <a-form-model class="log-form" :model="twiceWaterPump" ref="twiceWaterPump" :rules="rules" :label-col="{ span: 6 }"
        :wrapper-col="{ span: 14 }">
        <a-form-model-item label="泵房名称" prop="pumpName">
          <a-input placeholder="请输入" v-model="twiceWaterPump.pumpName" />
        </a-form-model-item>
        <a-form-model-item label="泵房编号">
          <a-input disabled placeholder="系统自动生成" v-model="twiceWaterPump.pumpNo" />
        </a-form-model-item>
        <a-form-model-item label="地址" prop="address">
          <a-input placeholder="请输入" v-model="twiceWaterPump.address" />
        </a-form-model-item>
        <a-form-model-item label="用户数" prop="userNum">
          <a-input placeholder="请输入" v-model="twiceWaterPump.userNum" />
        </a-form-model-item>
        <a-form-model-item label="建造年代" prop="buildingTime">
          <a-date-picker format="YYYY-MM-DD" valueFormat="YYYY-MM-DD" placeholder="建造年代"
            v-model="twiceWaterPump.buildingTime" />
        </a-form-model-item>
        <a-form-model-item label="泵房在线状态 " prop="isOnline">
          <a-select v-model="twiceWaterPump.isOnline" placeholder="请选择泵房在线状态">
            <a-select-option value="在线"> 在线 </a-select-option>
            <a-select-option value="离线"> 离线 </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="泵房预警状态" prop="isWarning">
          <a-select allowClear v-model="twiceWaterPump.isWarning" placeholder="请选择泵房预警状态">
            <a-select-option value="正常"> 正常 </a-select-option>
            <a-select-option value="预警"> 预警 </a-select-option>
            <a-select-option value="报警"> 报警 </a-select-option>
          </a-select>
          <!-- <span style="color: #ff3b3b; font-size: 8px">*泵房预警状态不做选择就是正常</span> -->
        </a-form-model-item>
        <!-- 上传图片 -->
        <a-form-model-item label="泵房图片">
          <a-upload-dragger name="file" :headers="headers" :action="uploadUrl" @change="handleChange">
            <a-icon type="inbox" />
          </a-upload-dragger>
        </a-form-model-item>
        <a-form-model-item label="流程图片">
          <a-upload-dragger name="file" :headers="headers" :action="uploadUrl" @change="handleChanges">
            <a-icon type="inbox" />
          </a-upload-dragger>
        </a-form-model-item>
        <a-form-model-item label="添加位置" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }" prop="locationInformation">
          <a-button type="primary" @click="addAddress">
            <span v-if="isUpdate">查看位置</span>
            <span v-else>添加位置</span>
          </a-button>
          <a-input placeholder="请输入" v-model="twiceWaterPump.geoJson" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </a-card>
</template>

<script>
import mixinViewModule from '@/mixin/common'
import LonlatMap from './component/lonlatMap.vue'
import { PERMISSION_ENUM } from '@/core/permission/permission'
import storage from 'store'
import { ACCESS_TOKEN } from '@/store/mutation-types'
const STORE_TYPE = { 1: '阿里云存储', 2: '本地存储' }
export default {
  components: { LonlatMap },
  name: 'PointCheck',
  mixins: [mixinViewModule],
  data () {
    return {
      mapVisible: false,
      queryUrl: '/pipe-network/twice_water_pumps/page',
      queryOneUrl: '',
      needQuery: false,
      // addOrUpdateUrl: '/pipe-network/twice_water_pumps', // 新增或更新数据url
      deleteUrl: '/pipe-network/twice_water_pumps', // 删除数据url
      recycleBinVisible: false,
      visible: false,
      visibles: false,
      confirmLoading: false,
      selectedRowKeys: [],
      pumpUrlg: '',
      titi: '',
      title: '',
      list: [],
      query: {
        pumpName: '',
        pumpNo: '',
        createTime: '',
        stateType: 1,
        buildingTime: ''
      },
      twiceWa: [],
      uploadUrl: `${process.env.VUE_APP_API_BASE_URL}manager/file/resources/upload`, // 上传文件URL
      headers: {
        Authorization: storage.get(ACCESS_TOKEN)
      },
      fileList: [],
      Thepicture: '',
      twiceWaterPump: {
        address: '',
        buildingTime: '',
        pumpNo: '',
        pumpName: '',
        geoJson: '',
        pumpUrl: '',
        flowUrl: '',
        userNum: '',
        isWarning: '',
        isOnline: ''
        // id: 0,
      },
      twids: 0,
      rules: {
        pumpName: [{ required: true, message: '请输入泵房名称', trigger: 'blur' }],
        pumpNo: [{ required: true, message: '请输入泵房编号', trigger: 'blur' }],
        address: [{ required: true, message: '请输入地址', trigger: 'blur' }],
        userNum: [
          { required: true, message: '请输入用户数', trigger: 'blur' },
          { pattern: /^[1-9]\d*$/, message: '请输入正整数', trigger: 'change' }
        ],
        isOnline: [{ required: true, message: '请选择泵房在线状态', trigger: 'blur' }],

        isWarning: [{ required: true, message: '请选择泵房预警状态', trigger: 'blur' }],
        buildingTime: [{ required: true, message: '请输入建造年代', trigger: 'change' }]
      },
      columns: [
        {
          title: '泵房编号',
          dataIndex: 'pumpNo',
          align: 'center',
          width: '150px'
        },
        {
          title: '泵房名称',
          dataIndex: 'pumpName'
        },
        {
          title: '泵房图片',
          dataIndex: 'pumpUrl',
          align: 'center',
          scopedSlots: { customRender: 'pumpUrl' }
        },
        {
          title: '流程图片',
          dataIndex: 'flowUrl',
          align: 'center',
          scopedSlots: { customRender: 'flowUrl' }
        },
        {
          title: '地址',
          dataIndex: 'address',
          align: 'center'
        },
        {
          title: '用户数',
          dataIndex: 'userNum',
          align: 'center'
        },
        {
          title: '建造年代',
          dataIndex: 'buildingTime',
          align: 'center'
        },
        {
          title: '添加时间',
          dataIndex: 'createTime',
          align: 'center'
        },
        {
          title: '操作',
          align: 'center',
          key: 'operation',
          fixed: 'right',
          width: 110,
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' }
        }
      ],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showTotal: (total) => `共 ${total} 条记录`,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100']
      },
      addOrUpdateForm: this.$form.createForm(this, { name: 'addOrUpdate' }),
      labelCol: { span: 4 },
      wrapperCol: { span: 18 }
    }
  },
  filters: {
    storeTypeFilter (key) {
      return STORE_TYPE[key]
    },
    permissionFilter (key) {
      const permission = PERMISSION_ENUM[key]
      return permission && permission.label
    }
  },
  created () {
    this.queryList()
  },
  methods: {
    // 图片展示
    pumpurlimg (i, j) {
      if (j == 1) {
        this.titi = '泵房图片'
        this.pumpUrlg = i.pumpUrl
      } else {
        this.titi = '流程图片'
        this.pumpUrlg = i.flowUrl
      }
      this.visibles = true
    },
    handleCancelh () {
      this.visibles = false
    },
    handleChange (info) {
      this.Thepicture = info.file.type.substr(0, 4)
      if (this.Thepicture !== 'imag') {
        info.fileList.splice(0, 1)
        this.$message.error('请上传正确格式的图片，如jpg、png、jpeg')
      }
      if (info.fileList.length == 2) {
        this.fileListsl = info.fileList.splice(0, 1)
      }
      const pumpUrl = info.file.pumpUrl
      if (pumpUrl !== 'uploading') {
        this.twiceWaterPump.pumpUrl = info.fileList[0].response.data.url
      }
      if (pumpUrl === 'done') {
        if (info.file.response.code === 0) {
          this.$message.success(`${info.file.name} 文件上传成功.`)
          this.queryList()
        } else {
          this.$message.error(`${info.file.name} ${info.file.response.message}.`)
        }
      } else if (pumpUrl === 'error') {
        this.$message.error(`${info.file.name} 文件上传失败.`)
      }
    },
    handleChanges (info) {
      this.Thepicture = info.file.type.substr(0, 4)
      if (this.Thepicture !== 'imag') {
        info.fileList.splice(0, 1)
        this.$message.error('请上传正确格式的图片，如jpg、png、jpeg')
      }
      if (info.fileList.length == 2) {
        this.fileListsl = info.fileList.splice(0, 1)
      }
      const flowUrl = info.file.flowUrl
      if (flowUrl !== 'uploading') {
        this.twiceWaterPump.flowUrl = info.fileList[0].response.data.url
      }
      if (flowUrl === 'done') {
        if (info.file.response.code === 0) {
          this.$message.success(`${info.file.name} 文件上传成功.`)
          this.queryList()
        } else {
          this.$message.error(`${info.file.name} ${info.file.response.message}.`)
        }
      } else if (flowUrl === 'error') {
        this.$message.error(`${info.file.name} 文件上传失败.`)
      }
    },
    handleCancel () {
      this.visible = false
      this.twiceWaterPump.isWarning = ''
      this.twiceWaterPump.geoJson = ''

      this.queryList()
      this.$refs.twiceWaterPump.resetFields()
    },
    visiblenew () {
      this.title = '新增'
      this.visible = true
      this.twiceWaterPump.isWarning = ''
      this.twiceWaterPump.geoJson = ''
    },
    // 修改
    addOrUHandle (id) {
      this.title = '编辑'
      this.visible = true
      this.twids = id
      this.$http.get('/pipe-network/twice_water_pumps/' + id).then((res) => {
        this.twiceWaterPump.address = res.data.address
        this.twiceWaterPump.buildingTime = res.data.buildingTime
        this.twiceWaterPump.pumpNo = res.data.pumpNo
        this.twiceWaterPump.pumpName = res.data.pumpName
        this.twiceWaterPump.geoJson = res.data.geoJson
        this.twiceWaterPump.pumpUrl = res.data.pumpUrl
        this.twiceWaterPump.flowUrl = res.data.flowUrl
        this.twiceWaterPump.userNum = res.data.userNum
        this.twiceWaterPump.isOnline = res.data.isOnline
        this.twiceWaterPump.isWarning = res.data.isWarning
      })
    },
    // 新增
    handleOk () {
      if (this.twids == 0) {
        this.$refs.twiceWaterPump.validate((valid) => {
          if (valid) {
            this.$http.post('/pipe-network/twice_water_pumps', this.twiceWaterPump).then((res) => {
              res.data[0] = this.twiceWaterPump
              this.visible = false
              this.$refs.twiceWaterPump.resetFields()
              this.queryList()
            })
          } else {
            return false
          }
        })
      } else {
        this.$refs.twiceWaterPump.validate((valid) => {
          if (valid) {
            this.$http
              .put('/pipe-network/twice_water_pumps', {
                id: this.twids,
                ...this.twiceWaterPump
              })
              .then((res) => {
                res.data[0] = this.twiceWaterPump
                this.visible = false
                this.$refs.twiceWaterPump.resetFields()
                this.queryList()
              })
          } else {
            console.log('error submit!!')
            return false
          }
        })
      }
    },
    addAddress () {
      this.mapVisible = true
      if (this.addOrUpdateForm.pointX) {
        var pointData = this.addOrUpdateForm.pointX.split(',')
        var newPointData = pointData.map((item) => {
          return (item = parseFloat(item))
        })
        console.log(newPointData, this.$refs) // [113.678351, 25.538859]
        this.$nextTick(() => {
          // this.$refs.lonlatMaps.changepoint(newPointData)
        })
      } else {
        this.$nextTick(() => {
          // this.$refs.lonlatMaps.changepoint([0, 0])
        })
      }
    },
    handleMapOk (data) {
      console.log('handleMapOk===', data)
      this.twiceWaterPump.address = data.address
      this.twiceWaterPump.geoJson = data.point
    },
    showLineLayer (record) {
      this.geoJson = record.geoJson
      this.mapVisible = true
    }
  }
}
</script>

<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}

.log-form {
  /deep/ .permission-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}

.a-card {
  width: 100%;
  height: 100%;
}
</style>
